import api from "./api"

export function fnCreateActivity(nBlockId, oActivityData) {
     const response = api.post(`/operational-panel-activity/${nBlockId}`, oActivityData);
     return response;
}

export function fnListActivities(nBlockId) {
     const response = api.get(`/operational-panel-activity/${nBlockId}`)
     return response
}

export function fnGetActivityDetails(nActivityId) {
     const response = api.get(`/operational-panel-activity/${nActivityId}/details`)
     return response

}

export function fnMoveActivities(nActivityId, nNewBlockId, bwill_be_last = false) {
     const response = api.put(`/operational-panel-activity/${nActivityId}`, { nnew_block_id: nNewBlockId, bwill_be_last: bwill_be_last })
     return response
}
export function fnUpdateActivity(oActivityData) {
     const response = api.patch(`/operational-panel-activity/${oActivityData?.opat_nid}`, oActivityData);
     return response;
}

export function fnReorderActivities(nBlockId, aPositions) {
     const response = api.patch(`/operational-panel-activity-order/${nBlockId}`, { positions: aPositions })
     return response
}
export function fnDeleteActivity(nActivityId, cPassword) {
     const response = api.delete(`operational-panel-activity/${nActivityId}`, { data: cPassword })
     return response
}

export function fnGetActivityHistory(nActivityId, cParams) {
     const response = api.get(`op-panel/activities/${nActivityId}/history${cParams ? `?${cParams}` : ""}`)
     return response
}

export function fnGetActivitiesByBlock(nBlockId, cParams) {
     const response = api.get(`/op-panel/block/${nBlockId}/activities${cParams ? `?${cParams}` : ""}`)
     return response
}
